import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import "./i18n";
import App from "./App";
import store from "./store/store";

import { GoogleOAuthProvider } from "@react-oauth/google";

Sentry.init({
  dsn: "https://c3d7ccf8244bd44ca0561d5bf78d3dca@o4509360463216640.ingest.de.sentry.io/4509360471408720",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  tracesSampleRate: 1.0, // enables performance monitoring
  replaysSessionSampleRate: 0.2, // records 10% of all sessions
  replaysOnErrorSampleRate: 1.0, // records 100% sessions with errors
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="1039706856351-aj07t9u81h5nnks18o9dj834a8a6ddha.apps.googleusercontent.com">
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
